import { getMaxRetries } from '@/api/client';
import { retryTransportFailureOnce } from '@/api/queryClient';

/**
 * A 200 whose `attribute_breakdown` is null or omitted: the server degraded the
 * grouped stats and alerted itself (vingapi#1210, #2110). Thrown by the
 * breakdown queryFn so the query retries it quietly (Q-506 card 1542 b) and the
 * panel shows its failed state after the budget. It is not a client crash:
 * `shouldReportError` returns false for it.
 */
export class BreakdownUnavailableError extends Error {
  constructor() {
    super('The server answered without an attribute breakdown');
    this.name = 'BreakdownUnavailableError';
  }
}

/**
 * The ONE sanctioned per-query retry (Q-506 card 1542 b), specific to the
 * breakdown query: a null / omitted breakdown is retried quietly up to
 * `getMaxRetries()` times (client.ts's RETRY_CONFIG, read each time, never
 * copied); every other error keeps the app rule, so a 5xx is still client.ts's
 * alone to retry and never multiplies. It takes no arguments, so it cannot be
 * pointed at anything else; `oneRetryOwner.guard.test.ts` pins its single use.
 */
export function retryBreakdownUnavailable(failureCount: number, error: unknown): boolean {
  return error instanceof BreakdownUnavailableError
    ? failureCount < getMaxRetries()
    : retryTransportFailureOnce(failureCount, error);
}
